import React, { useState, useRef, useEffect } from 'react';
import { useLab } from '../LabContext';
import { ChevronDownIcon } from './icons';
import './LabSelector.css';

export function LabSelector() {
  const { labs, labSelection, setLabSelection } = useLab();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  if (labs.length <= 1) return null;

  const selectedName = labs.find(l => l.id === labSelection)?.attributes?.name ?? '';

  return (
    <div className="lab-selector" ref={ref}>
      <button
        className="lab-selector-trigger"
        onClick={() => setOpen(!open)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="lab-selector-label">{selectedName}</span>
        <ChevronDownIcon />
      </button>
      {open && (
        <div className="lab-selector-dropdown" role="listbox" aria-label="Select lab">
          {labs.map((lab) => (
            <button
              key={lab.id}
              className={`lab-selector-option${labSelection === lab.id ? ' active' : ''}`}
              role="option"
              aria-selected={labSelection === lab.id}
              onClick={() => { setLabSelection(lab.id!); setOpen(false); }}
            >
              {lab.attributes?.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
